export default __webpack_public_path__ + "static/media/search-guide.2cb06bb4.png";